/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const ClothingShirtScoop = ({
  className,
  clothingShirtScoop = "/img/clothing-shirt-scoop-neck.svg",
}) => {
  return (
    <img
      className={`clothing-shirt-scoop ${className}`}
      alt="Clothing shirt scoop"
      src={clothingShirtScoop}
    />
  );
};

ClothingShirtScoop.propTypes = {
  clothingShirtScoop: PropTypes.string,
};
